<template>
  <div id="panel">
  	<PanelContent/>
  </div>
</template>

<script>
import PanelContent from "@/components/PanelContent";

export default {
  name: 'Panel',
  components: {
	PanelContent,
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Panel.vue